var $6ff942e88faf5460$exports = {};
$6ff942e88faf5460$exports = {
    "minimum": `Minimum`,
    "maximum": `Maximum`
};


export {$6ff942e88faf5460$exports as default};
//# sourceMappingURL=en-US.module.js.map
